import React, { useLayoutEffect } from 'react';

const useLayoutEffectCancelled = (
  serviceFunc: (canceller: AbortController) => () => void,
  deps: any[]
) => {
  useLayoutEffect(() => {
    const canceller = new AbortController();

    const unsub = serviceFunc(canceller);

    return () => {
      canceller.abort();
      unsub();
    };
  }, [...deps]);
};

export default useLayoutEffectCancelled;
